import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useLocation } from "react-router";
import { getUserRequest, buildReportAsync, getTask, getTaskResult } from "../../api";
import React, { useState } from "react";
import "./test_async.css";

const TestAsync = () => {
  const location = useLocation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const userRequest = params.get("user_request");
  const persona = params.get("persona");
  console.log("userRequest", userRequest);
  console.log("persona", persona);
  const userRequestQuery = useQuery({
    queryKey: ["userRequest", { userRequest }],
    queryFn: ({ queryKey }) => {
      const { userRequest } = queryKey[1];
      return getUserRequest({ id: userRequest });
    },
    enabled: !!userRequest,
  });

  const createTaskQuery = useQuery({
    queryKey: ["createtask", { userRequest: userRequestQuery.data?.user_request, persona }],
    queryFn: async ({ queryKey }) => {
      const { userRequest, persona } = queryKey[1];
      return buildReportAsync({ userRequest, persona });
    },
    enabled: !!userRequestQuery.data?.user_request,
  });

  const [poll, setPoll] = useState(true);
  const taskQuery = useQuery({
    queryKey: ["task", { task_id: createTaskQuery.data?.task_id }],
    queryFn: async ({ queryKey }) => {
      const { task_id } = queryKey[1];
      if (!task_id) {
        return {};
      }
      let task = await getTask({ task_id: task_id });
      console.log(task);
      if (task.status === "done") {
        setPoll(false);
      }
      return task;
    },
    enabled: !!createTaskQuery,
    refetchInterval: createTaskQuery && poll ? 1000 : false,
  });

  const taskResultQuery = useQuery({
    queryKey: ["report", { task_id: createTaskQuery.data?.task_id }],
    queryFn: async ({ queryKey }) => {
      const { task_id } = queryKey[1];
      return getTaskResult({ task_id: task_id });
    },
    enabled: taskQuery.data?.status == "done",
  });

  return (
    <div className="test_wrapper">
      <h1>User Request</h1>
      <textarea
        value={userRequestQuery.data?.user_request || userRequestQuery.status}
        readOnly
      ></textarea>
      <h1>Create Task</h1>
      <textarea
        value={JSON.stringify(createTaskQuery.data) || createTaskQuery.status}
        readOnly
      ></textarea>
      <h1>Task Polling</h1>
      <textarea value={JSON.stringify(taskQuery.data) || taskQuery.status} readOnly></textarea>
      <h1>Task</h1>
      <textarea
        value={JSON.stringify(taskResultQuery.data) || taskResultQuery.status}
        readOnly
      ></textarea>
    </div>
  );
};

export default TestAsync;
